import vediAPI from "../../utils/vedi-api/vediAPI";
import * as actionTypes from "./actionTypes";

const loginSuccessed = (payload) => {
  return {
    type: actionTypes.LOGIN,
    payload,
  };
};

const logoutFromApp = () => ({
  type: actionTypes.LOGOUT,
});

export const logout = () => {
  return (dispatch) =>
    vediAPI.put("/v2/Usuario/CerrarSesion").then(({ data }) => {
      if (!data.ok) {
        throw new Error(data.error);
      }
      dispatch(logoutFromApp());
    });
};

const _getUserImage = (photoID, male) => {
  let urlUserPhoto = photoID
    ? `${process.env.REACT_APP_CBA_FILES}/Archivo/`
    : null;
  if (photoID) {
    urlUserPhoto += photoID + "/2";
  }
  return urlUserPhoto;
};

const checkMissingUserData = (userData) => {
  const hasEmail = userData.email && userData.email.trim() !== "";
  const hasPhone =
    userData.telefonoCelular &&
    userData.telefonoCelular.trim() !== "" &&
    userData.telefonoCelular !== "-";

  return !hasEmail || !hasPhone;
};

const showMissingDataAlert = (dispatch) => {
  const hasShownAlert = sessionStorage.getItem("hasShownMissingDataAlert");

  if (!hasShownAlert) {
    sessionStorage.setItem("hasShownMissingDataAlert", "true");
    dispatch(showMissingDataPopup());
  }
};

export const login = (token, refreshToken) => {
  return (dispatch) => {
    vediAPI
      .get(`/v3/Usuario`, { headers: { "--Token": token } })
      .then(({ data }) => {
        if (!data.ok) {
          throw new Error(data.error);
        }
        const userData = data.return;
        const urlUserPhoto = _getUserImage(
          userData.identificadorFotoPersonal,
          userData.idSexo
        );

        // Verificar si faltan datos importantes
        if (checkMissingUserData(userData)) {
          showMissingDataAlert(dispatch);
        }

        dispatch(
          loginSuccessed({
            user: { ...userData, urlUserPhoto },
            token,
            refreshToken,
          })
        );
      });
  };
};

export const toggleEdit = () => ({
  type: actionTypes.TOGGLE_EDIT,
});

const updateUserData = (updatedUserData) => ({
  type: actionTypes.UPDATE_USER_DATA,
  updatedUserData,
});

const updateUserDataFailed = (errorMsg) => ({
  type: actionTypes.UPDATE_USER_DATA_FAILED,
  errorMsg,
});

const initUpdateUserData = () => ({
  type: actionTypes.INIT_UPDATE_USER_DATA,
});

export const updateUser = (updatedUserData) => {
  return (dispatch) => {
    dispatch(initUpdateUserData());
    vediAPI
      .put("/v3/Usuario", updatedUserData)
      .then(({ data }) => {
        if (!data.ok) {
          throw new Error(data.error);
        }
        dispatch(updateUserData(updatedUserData));
      })
      .catch((error) => dispatch(updateUserDataFailed(error.message)));
  };
};

export const resetUsuarioSuccess = () => ({ type: actionTypes.RESET_SUCCESS });

//#endregion

//#region 2FA
export const guardarConfiguracion2FA = (token, estado) => {
  //permite habilitar o deshabilitar 2FA
  return (dispatch) => {
    vediAPI
      .post(`/v2/Usuario/GuardarConfiguracion2FA`, {
        Token: token,
        Estado: estado, //0: inactivo, 1: activo
      })
      .then(({ data }) => {
        if (!data.ok) {
          throw new Error(data.error);
        }

        dispatch(updateConfiguracion2FA(estado === 1));
      })
      .catch((error) => {
        console.error(error);
      });
  };
};

const updateConfiguracion2FA = (payload) => ({
  type: actionTypes.UPDATE_CONFIGURACION2FA,
  payload,
});

export const generarCodigo2FA = (token, metodo = 0) => {
  //permite habilitar o deshabilitar 2FA
  return async (dispatch) => {
    try {
      const { data } = await vediAPI.post(`/v2/Usuario/GenerarCodigo2FA`, {
        Token: token,
        MetodoEnvio: metodo, //0: email, 1: smscorto
      });
      if (!data.ok) {
        throw new Error(data.error);
      }
      dispatch(updateCodigo2FA(data.return));
      return data;
    } catch (error) {
      console.error(error);
    }
  };
};

const updateCodigo2FA = (payload) => ({
  type: actionTypes.UPDATE_CODIGO2FA,
  payload,
});

export const validarCodigo2FA = (token, codigo) => {
  //permite habilitar o deshabilitar 2FA
  return async (dispatch) => {
    try {
      const { data } = await vediAPI.post(`/v2/Usuario/ValidarCodigo2FA`, {
        Token: token,
        Codigo: codigo,
      });
      if (!data.ok) throw new Error(data.error);
      dispatch(updateValidacionCodigo2FA(data.return)); //bool
      return data;
    } catch (error) {
      console.error(error);
    }
  };
};

const updateValidacionCodigo2FA = (payload) => ({
  type: actionTypes.UPDATE_VALIDACION_CODIGO2FA,
  payload,
});

export const toggleModoAdultoMayor = (active = false) => {
  return async (dispatch) => {
    try {
      const { data } = await vediAPI.post(
        `/v3/Usuario/ModoAdultoMayor?activa=${active}`
      );
      if (!data.ok) throw new Error(data.error);
      dispatch(setModoAdultoMayor(active));
      return data;
    } catch (error) {
      console.error(error);
    }
  };
};

export const setModoAdultoMayor = (payload) => ({
  type: actionTypes.SET_MODO_ADULTO_MAYOR,
  payload,
});

export const showMissingDataPopup = () => ({
  type: actionTypes.SHOW_MISSING_DATA_POPUP,
});

export const hideMissingDataPopup = () => ({
  type: actionTypes.HIDE_MISSING_DATA_POPUP,
});

export const setNotificationToken = (token) => ({
  type: actionTypes.SET_NOTIFICATION_TOKEN,
  payload: token,
});

const initUpdateNotificationSettings = () => ({
  type: actionTypes.INIT_UPDATE_NOTIFICATION_SETTINGS,
});

const updateNotificationSettingsSuccess = (settings) => ({
  type: actionTypes.UPDATE_NOTIFICATION_SETTINGS,
  payload: settings,
});

const updateNotificationSettingsFailed = (errorMsg) => ({
  type: actionTypes.UPDATE_NOTIFICATION_SETTINGS_FAILED,
  errorMsg,
});

// Obtener tipos de notificaciones disponibles
export const fetchTiposNotificaciones = () => {
  return async (dispatch) => {
    try {
      const { data } = await vediAPI.post("/v3/Usuario/TiposNotificaciones");

      if (!data.ok) {
        throw new Error(data.error);
      }

      return data.return;
    } catch (error) {
      console.error("Error obteniendo tipos de notificaciones:", error);
      throw error;
    }
  };
};

// Obtener preferencias actuales del usuario
export const fetchPreferenciasNotificaciones = (tokenDispositivo) => {
  return async (dispatch) => {
    try {
      const { data } = await vediAPI.post(
        "/v3/Usuario/PrefernciasNotisUsuario",
        {},
        { headers: { "--TokenDis": tokenDispositivo } }
      );

      if (!data.ok) {
        throw new Error(data.error);
      }

      return data.return;
    } catch (error) {
      console.error("Error obteniendo preferencias:", error);
      throw error;
    }
  };
};

// Actualizar configuración de notificaciones
export const updateNotificationSettings = (preferencias, tokenDispositivo) => {
  return async (dispatch) => {
    dispatch(initUpdateNotificationSettings());
    try {
      const promises = preferencias.map((preferencia) =>
        vediAPI.post(
          "/v3/Usuario/AsignarPrefernciasNotisUsuario",
          {
            IdUsuario: preferencia.IdUsuario,
            IdTipoNotificacion: preferencia.IdTipoNotificacion,
            Activa: preferencia.Activa,
            IdDispositivoSesion: preferencia.IdDispositivoSesion,
          },
          { headers: { "--TokenDis": tokenDispositivo } }
        )
      );

      const responses = await Promise.all(promises);

      // Verificar que todas las respuestas sean exitosas
      const allSuccessful = responses.every((response) => response.data.ok);

      if (!allSuccessful) {
        throw new Error("Error al actualizar algunas preferencias");
      }

      dispatch(updateNotificationSettingsSuccess(preferencias));
      return responses;
    } catch (error) {
      dispatch(updateNotificationSettingsFailed(error.message));
      throw error;
    }
  };
};
